import type { ThemeConfig } from "../../types";

export const darkTheme: ThemeConfig = {
  weak: { color: "#ef4444", label: "Weak" },
  fair: { color: "#f97316", label: "Fair" },
  good: { color: "#3b82f6", label: "Good" },
  strong: { color: "#22c55e", label: "Strong" },
};
